import { useGoogleAnalytics } from '@happynumbers/front-utils';
import { gaTrackerIds } from '../../pages/utils';
var useAppGoogleAnalytics = function () { return useGoogleAnalytics(gaTrackerIds); };
export { useAppGoogleAnalytics };
